import React from "react";
import YoutubePlayer from "../Player/YoutubePlayer";
import { getYoutubeEmbedUrl } from "@/utils/youtube";
import dynamic from "next/dynamic";
const Modal = dynamic(() => import("antd/es/modal"), { ssr: false });

export default function CourseVideoModal({
  isModalOpen,
  setIsModalOpen,
  course,
}) {
  return (
    <Modal
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      centered
      width={800}
      className="video-modal"
      styles={{
        body: {
          padding: 0,
        },
      }}
      destroyOnHidden
    >
      <div className="aspect-video w-full">
        <YoutubePlayer url={isModalOpen ? course?.promo_video : null} />
      </div>
    </Modal>
  );
}
